import React, { useContext, useState, useEffect } from "react";
import { Card, Button, Form, Row, Col, Modal } from "react-bootstrap";
import "./css/HistTableStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { MaintenanceContext } from "../../../contexts/MaintenanceContext";
import api from "../../../axiosConfig";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { popup } from "../../common/popup";

const MachinesTab = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const statusParam = query.get("status");
  const sectorParam = query.get("sector");
  const {
    machines,
    loading,
    handleMarkUnderMaintenance,
    getStatusBadge,
    finishMaintenance,
    fetchMachines,
  } = useContext(MaintenanceContext);

  //state perawatan
  const [uraianDirect, setUraianDirect] = useState("");
  const [tindakanDirect, setTindakanDirect] = useState("");
  const [hasilDirect, setHasilDirect] = useState("");
  const [picDirect, setPicDirect] = useState("");

  const [savingFinish, setSavingFinish] = useState(false);
  const [savingDirect, setSavingDirect] = useState(false);
  const [filteredMachines, setFilteredMachines] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState(sectorParam || "all");
  const [selectedStatus] = useState(statusParam || "");
  const [search, setSearch] = useState("");
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [pauseLoading, setPauseLoading] = useState({});
  const [spareparts, setSpareparts] = useState([]);
  const [uraianMasalah, setUraianMasalah] = useState("");
  const [dikerjakanOleh, setDikerjakanOleh] = useState("");
  const [dicekOleh, setDicekOleh] = useState("");
  const [gejalaMasalah, setGejalaMasalah] = useState("");
  const [tindakanPenyebab, setTindakanPenyebab] = useState("");
  const [evakuasiPerbaikan, setEvakuasiPerbaikan] = useState("");
  const [pausedMap, setPausedMap] = useState({});
  const [keterangan, setKeterangan] = useState("");
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [showDirectModal, setShowDirectModal] = useState(false);
  const [keteranganDirect, setKeteranganDirect] = useState("");

  const [technicians, setTechnicians] = useState([]);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get("/sectors").then((res) => setSectors(res.data));

    api.get("/technicians").then((res) => {
      setTechnicians(res.data);
    });

    // Kategori item part diambil dinamis agar kategori baru (mis. mekanik,
    // pneumatic) yang ditambah super admin ikut muncul saat pemakaian.
    api
      .get("/stock-items/categories")
      .then((res) => setCategories(res.data.data || []))
      .catch((err) => console.error("Gagal ambil kategori:", err));
  }, []);

  useEffect(() => {
    const map = {};
    machines.forEach((m) => {
      map[m.id] = Boolean(m.maintenance?.is_paused);
    });
    setPausedMap(map);
  }, [machines]);

  useEffect(() => {
    if (sectorParam) {
      setSelectedSector(sectorParam);
    }
  }, [sectorParam]);

  const pauseMaintenance = async (machineId) => {
    if (pauseLoading[machineId]) return;
    if (pausedMap[machineId]) return;

    const machine = machines.find((m) => m.id === machineId);
    if (!machine || machine.status !== "Under Maintenance") {
      popup.alert("Maintenance belum dimulai");
      return;
    }

    try {
      setPauseLoading((p) => ({ ...p, [machineId]: true }));

      // ✅ PANGGIL API PAUSE
      await api.put(`/maintenance/pause/${machineId}`);

      // ✅ REFRESH DATA
      await fetchMachines();

      // ❌ JANGAN setPausedMap manual
    } catch (err) {
      console.error(err);
      popup.error(err.response?.data?.msg || "Gagal pause maintenance");
    } finally {
      setPauseLoading((p) => ({ ...p, [machineId]: false }));
    }
  };

  const resumeMaintenance = async (machineId) => {
    if (pauseLoading[machineId]) return;

    try {
      setPauseLoading((p) => ({ ...p, [machineId]: true }));

      await api.put(`/maintenance/resume/${machineId}`);

      // ✅ REFRESH DATA
      await fetchMachines();
    } catch (err) {
      console.error(err);
      popup.error(err.response?.data?.msg || "Gagal lanjut maintenance");
    } finally {
      setPauseLoading((p) => ({ ...p, [machineId]: false }));
    }
  };

  useEffect(() => {
    let data = [...machines];

    // 🔹 Filter sektor (seperti user page)
    if (selectedSector !== "all") {
      data = data.filter((m) => {
        const sectorId = m.sector?.id ?? m.sector?._id ?? m.sector_id;

        return String(sectorId) === String(selectedSector);
      });
    }

    // 🔹 Filter status
    if (selectedStatus) {
      data = data.filter((m) => m.status === selectedStatus);
    }

    // 🔍 Filter search
    if (search.trim()) {
      const keyword = search.toLowerCase();
      data = data.filter(
        (m) =>
          m.name?.toLowerCase().includes(keyword) ||
          m.code?.toLowerCase().includes(keyword) ||
          m.sector?.name?.toLowerCase().includes(keyword),
      );
    }

    // 🔥 PRIORITAS STATUS (rusak di atas)
    data.sort((a, b) => {
      const priorityOrder = {
        "Need Maintenance": 1,
        "Under Maintenance": 2,
        Operational: 3,
      };

      return (priorityOrder[a.status] || 99) - (priorityOrder[b.status] || 99);
    });

    setFilteredMachines(data);
  }, [machines, selectedSector, selectedStatus, search]);

  const fetchStockItems = async (index, category) => {
    if (!category) return;
    try {
      const res = await api.get("/stock-items", { params: { category } });
      setSpareparts((prev) => {
        const copy = [...prev];
        copy[index].stockItems = res.data || [];
        return copy;
      });
    } catch {
      setSpareparts((prev) => {
        const copy = [...prev];
        copy[index].stockItems = [];
        return copy;
      });
    }
  };

  const addSparepart = () => {
    setSpareparts((prev) => [
      ...prev,
      { id: uuidv4(), category: "", stockItems: [], itemId: "", qty: 1 },
    ]);
  };

  const removeSparepart = (index) => {
    setSpareparts((prev) => prev.filter((_, i) => i !== index));
  };

  const submitFinish = async () => {
    if (savingFinish) return; // cegah double submit saat jaringan lag
    if (!uraianMasalah || !dikerjakanOleh || !dicekOleh) {
      popup.error("Data wajib diisi");
      return;
    }

    setSavingFinish(true);
    const payload = {
      gejalaMasalah,
      uraianMasalah,
      tindakanPenyebab,
      evakuasiPerbaikan,
      dikerjakanOleh,
      dicekOleh,
      keterangan,

      spareparts,
    };

    try {
      const ok = await finishMaintenance(selectedMachine.id, payload);
      if (!ok) {
        popup.error("Gagal menyelesaikan perbaikan");
        return;
      }

      popup.success("Perbaikan selesai");

      // reset form
      setGejalaMasalah("");
      setUraianMasalah("");
      setTindakanPenyebab("");
      setEvakuasiPerbaikan("");
      setDikerjakanOleh("");
      setDicekOleh("");
      setKeterangan("");
      setSpareparts([]);

      setShowFinishModal(false);

      fetchMachines();
    } catch (err) {
      console.error("Finish maintenance error:", err);

      popup.error(err.response?.data?.msg || "Gagal finish maintenance");
    } finally {
      setSavingFinish(false);
    }
  };

  const submitDirect = async () => {
    if (savingDirect) return; // cegah double submit saat jaringan lag
    if (!uraianDirect || !picDirect) {
      popup.error("Data wajib diisi");
      return;
    }

    setSavingDirect(true);
    const payload = {
      uraianMasalah: uraianDirect,
      tindakanPenyebab: tindakanDirect,
      evakuasiPerbaikan: hasilDirect,
      dikerjakanOleh: picDirect,
      dicekOleh: picDirect,
      keterangan: keteranganDirect,

      spareparts,
    };

    try {
      await api.post(`/maintenance/direct/${selectedMachine.id}`, payload);

      popup.success("Perawatan selesai");

      // 🔥 RESET FORM
      setUraianDirect("");
      setTindakanDirect("");
      setHasilDirect("");
      setPicDirect("");
      setKeteranganDirect("");

      // 🔥 RESET SPAREPART
      setSpareparts([]);

      // 🔥 TUTUP MODAL
      setShowDirectModal(false);

      fetchMachines();
    } catch (err) {
      console.error(err);
      popup.error("Gagal direct maintenance");
    } finally {
      setSavingDirect(false);
    }
  };

  const downloadExcel = () => {
    if (!filteredMachines.length) {
      popup.alert("Data kosong");
      return;
    }

    const wsData = [
      ["No", "Kode", "Nama Mesin", "Sektor", "Tahun Aktif", "Status"],
      ...filteredMachines.map((m, i) => [
        i + 1,
        m.code || "-",
        m.name || "-",
        m.sector?.name || "-",
        m.activation_date
          ? new Date(m.activation_date).toLocaleDateString("id-ID")
          : "-",
        m.status,
      ]),
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    XLSX.utils.book_append_sheet(wb, ws, "Mesin");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "daftar_mesin.xlsx",
    );
  };

  if (loading) return <div className="text-center p-5">Loading...</div>;
  const currentSectorName =
    sectors.find((s) => String(s.id) === String(selectedSector))?.name || "";

  return (
    <>
      <Card style={{ height: "calc(103vh - 115px)", marginTop: "-18px" }}>
        <Card.Header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h5 style={{ fontSize: "30px" }}>
            Daftar Mesin {currentSectorName && `- ${currentSectorName}`}
          </h5>

          <div style={{ display: "flex", gap: "10px" }}>
            <Row style={{ display: "flex" }}>
              <Col md={4}>
                <Form.Select
                  value={selectedSector}
                  onChange={(e) => setSelectedSector(e.target.value)}
                >
                  <option value="all">Semua Sektor</option>
                  {sectors.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="🔍 Cari..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Button variant="success" onClick={downloadExcel}>
                  <FontAwesomeIcon icon={faSync} className="me-1" /> Export
                  Excel
                </Button>
              </Col>
            </Row>
          </div>
        </Card.Header>

        <Card.Body style={{ padding: 0, flex: 1, overflow: "hidden" }}>
          <div style={{ height: "100%", overflowY: "auto" }}>
            <table className="hist-table machine-hist mb-0">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 1,
                }}
              >
                <tr>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>No</th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>Kode</th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Nama Mesin
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Tahun Aktif
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Sektor
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Tools
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Status
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>Aksi</th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Perawatan
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredMachines.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="text-center">
                      Data belum ada
                    </td>
                  </tr>
                ) : (
                  filteredMachines.map((m, i) => (
                    <tr key={`${m.id}-${i}`}>
                      <td>{i + 1}</td>
                      <td>{m.code || "-"}</td>
                      <td className="cell-left">{m.name || "-"}</td>
                      <td>
                        {m.activation_date
                          ? new Date(m.activation_date).toLocaleDateString(
                              "id-ID",
                            )
                          : "-"}
                      </td>
                      <td>{m.sector?.name || "-"}</td>
                      <td
                        className="cell-left"
                        style={{ maxWidth: "240px", whiteSpace: "normal" }}
                      >
                        {m.tools && m.tools.length > 0 ? (
                          <span title={m.tools.map((t) => t.part_name).join(", ")}>
                            {m.tools.map((t) => t.part_name).join(", ")}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{getStatusBadge(m.status)}</td>
                      <td className="d-flex" style={{ gap: "10px" }}>
                        {m.status === "Need Maintenance" && (
                          <Button
                            size="sm"
                            variant="warning"
                            onClick={() => handleMarkUnderMaintenance(m.id)}
                          >
                            Kerjakan
                          </Button>
                        )}

                        {m.status === "Under Maintenance" && (
                          <>
                            {pausedMap[m.id] ? (
                              <Button
                                size="sm"
                                variant="info"
                                onClick={() => resumeMaintenance(m.id)}
                              >
                                ▶️ Lanjutkan
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                variant="secondary"
                                onClick={() => pauseMaintenance(m.id)}
                              >
                                ⏸ Pause
                              </Button>
                            )}

                            <Button
                              size="sm"
                              variant="success"
                              onClick={async () => {
                                try {
                                  console.log("🔥 MACHINE:", m);

                                  setSelectedMachine(m);

                                  // =====================================
                                  // RESET FORM DULU
                                  // =====================================
                                  setGejalaMasalah("");
                                  setUraianMasalah("");
                                  setTindakanPenyebab("");
                                  setEvakuasiPerbaikan("");
                                  setDikerjakanOleh("");
                                  setDicekOleh("");
                                  setKeterangan("");

                                  // =====================================
                                  // AMBIL HISTORY
                                  // =====================================
                                  const res = await api.get(
                                    `/maintenance/history-active/${m.id}`,
                                  );

                                  console.log(
                                    "🔥 RESPONSE FULL:",
                                    JSON.stringify(res.data, null, 2),
                                  );

                                  const data = res.data || {};

                                  console.log("🔥 HISTORY DATA:", data);

                                  // =====================================
                                  // ISI STATE DARI DATABASE
                                  // =====================================
                                  setGejalaMasalah(data.gejala_masalah ?? "");
                                  setUraianMasalah(data.uraian_masalah ?? "");
                                  setTindakanPenyebab(
                                    data.tindakan_penyebab ?? "",
                                  );
                                  setEvakuasiPerbaikan(
                                    data.evakuasi_perbaikan ?? "",
                                  );
                                  setDikerjakanOleh(data.dikerjakan_oleh ?? "");
                                  setDicekOleh(data.dicek_oleh ?? "");
                                  setKeterangan(data.keterangan ?? "");

                                  // =====================================
                                  // BUKA MODAL TERAKHIR
                                  // =====================================
                                  setShowFinishModal(true);
                                } catch (err) {
                                  console.error("❌ ERROR:", err);

                                  popup.error(
                                    err.response?.data?.msg ||
                                      "Gagal ambil history maintenance",
                                  );
                                }
                              }}
                            >
                              ✔ Selesai
                            </Button>
                          </>
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={() => {
                            setSelectedMachine(m);
                            setShowDirectModal(true);
                          }}
                        >
                          🔧 Perawatan
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showFinishModal}
        onHide={() => setShowFinishModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Penggunaan Sparepart</Modal.Title>
        </Modal.Header>

        <Form className="px-3 pt-2">
          <Form.Group className="mb-3">
            <Form.Label>Dikerjakan Oleh</Form.Label>

            <Form.Select
              value={dikerjakanOleh}
              onChange={(e) => setDikerjakanOleh(e.target.value)}
            >
              <option value="">Pilih Teknisi</option>

              {technicians.map((user) => (
                <option key={user.id} value={user.name}>
                  {user.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Dicek Oleh</Form.Label>

            <Form.Select
              value={dicekOleh}
              onChange={(e) => setDicekOleh(e.target.value)}
            >
              <option value="">Pilih Checker</option>

              {technicians.map((user) => (
                <option key={user.id} value={user.name}>
                  {user.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {spareparts.map((sp, index) => (
            <Card key={sp.id} className="mb-3 p-3 border">
              <Row className="mb-2">
                <Col md={10}>
                  <Form.Label>Kategori</Form.Label>
                  <Form.Select
                    value={sp.category}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          category: val,
                          itemId: "",
                        };
                        return copy;
                      });
                      fetchStockItems(index, val);
                    }}
                  >
                    <option value="">Pilih</option>
                    {categories.map((k) => (
                      <option key={k} value={k}>
                        {k.charAt(0).toUpperCase() + k.slice(1)}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={2} className="d-flex align-items-end">
                  {spareparts.length > 1 && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => removeSparepart(index)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  )}
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Label>Item</Form.Label>

                  <Select
                    placeholder={
                      sp.category ? "Cari item..." : "Pilih kategori dulu"
                    }
                    isClearable
                    isSearchable
                    isDisabled={!sp.category}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                      control: (base, state) => ({
                        ...base,
                        minHeight: "38px",
                        borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(13,110,253,.25)"
                          : "none",
                        "&:hover": {
                          borderColor: "#86b7fe",
                        },
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 8px",
                      }),

                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "38px",
                      }),
                    }}
                    value={
                      sp.stockItems
                        .map((i) => ({
                          value: i.id,
                          label: `${i.part_name}${
                            i.spesifikasi ? ` | ${i.spesifikasi}` : ""
                          } | Stock: ${i.stock} ${i.unit}`,
                        }))
                        .find((opt) => opt.value === sp.itemId) || null
                    }
                    options={sp.stockItems.map((i) => ({
                      value: i.id,
                      label: `${i.part_name}${
                        i.spesifikasi ? ` | ${i.spesifikasi}` : ""
                      } | Stock: ${i.stock} ${i.unit}`,
                    }))}
                    onChange={(selected) => {
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          itemId: selected ? selected.value : null,
                        };
                        return copy;
                      });
                    }}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Qty</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={sp.qty}
                    onChange={(e) =>
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          qty: Number(e.target.value),
                        };
                        return copy;
                      })
                    }
                  />
                </Col>
              </Row>
            </Card>
          ))}

          <Button
            variant="outline-primary"
            size="sm"
            onClick={addSparepart}
            className="mb-3"
          >
            <FontAwesomeIcon icon={faPlus} /> Tambah Sparepart
          </Button>

          <Form.Group className="mb-3">
            <Form.Label>Gejala Masalah</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={gejalaMasalah}
              onChange={(e) => setGejalaMasalah(e.target.value)}
              placeholder="Gejala Masalah"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Uraian Masalah & Penyebab Masalah</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={uraianMasalah}
              onChange={(e) => setUraianMasalah(e.target.value)}
              placeholder="Uraian Masalah & Penyebab Masalah"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tindakan / Penyelesaian Masalah</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={tindakanPenyebab}
              onChange={(e) => setTindakanPenyebab(e.target.value)}
              placeholder="Tindakan / Penyelesaian Masalah"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Evaluasi Perbaikan</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={evakuasiPerbaikan}
              onChange={(e) => setEvakuasiPerbaikan(e.target.value)}
              placeholder="Evaluasi Perbaikan"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Keterangan</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Isi keterangan"
              value={keterangan}
              onChange={(e) => setKeterangan(e.target.value)}
            />
          </Form.Group>
        </Form>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFinishModal(false)}>
            Batal
          </Button>
          <Button variant="success" onClick={submitFinish} disabled={savingFinish}>
            {savingFinish ? "Menyimpan..." : "Selesai"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showDirectModal}
        onHide={() => {
          setShowDirectModal(false);
          setKeteranganDirect("");
          setUraianDirect("");
          setTindakanDirect("");
          setHasilDirect("");
          setPicDirect("");

          setSpareparts([]);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perawatan Langsung</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>PIC</Form.Label>
            <Form.Select
              value={picDirect}
              onChange={(e) => setPicDirect(e.target.value)}
            >
              <option value="">-- Pilih PIC --</option>
              {technicians.map((t) => (
                <option key={t.id} value={t.name}>
                  {t.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>Uraian Masalah</Form.Label>
            <Form.Control
              as="textarea"
              onChange={(e) => setUraianDirect(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Tindakan </Form.Label>
            <Form.Control
              as="textarea"
              onChange={(e) => setTindakanDirect(e.target.value)}
            />
          </Form.Group>

          {spareparts.map((sp, index) => (
            <Card key={sp.id} className="mb-2 p-3 border mt-3">
              <Row className="mb-2">
                <Col md={10}>
                  <Form.Label>Kategori</Form.Label>
                  <Form.Select
                    value={sp.category}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          category: val,
                          itemId: "",
                        };
                        return copy;
                      });
                      fetchStockItems(index, val);
                    }}
                  >
                    <option value="">Pilih</option>
                    {categories.map((k) => (
                      <option key={k} value={k}>
                        {k.charAt(0).toUpperCase() + k.slice(1)}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={2} className="d-flex align-items-end">
                  {spareparts.length > 1 && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => removeSparepart(index)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  )}
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Label>Item</Form.Label>

                  <Select
                    placeholder={
                      sp.category ? "Cari item..." : "Pilih kategori dulu"
                    }
                    isClearable
                    isSearchable
                    isDisabled={!sp.category}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                      control: (base, state) => ({
                        ...base,
                        minHeight: "38px",
                        borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(13,110,253,.25)"
                          : "none",
                        "&:hover": {
                          borderColor: "#86b7fe",
                        },
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 8px",
                      }),

                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "38px",
                      }),
                    }}
                    value={
                      sp.stockItems
                        .map((i) => ({
                          value: i.id,
                          label: `${i.part_name}${
                            i.spesifikasi ? ` | ${i.spesifikasi}` : ""
                          } | Stock: ${i.stock} ${i.unit}`,
                        }))
                        .find((opt) => opt.value === sp.itemId) || null
                    }
                    options={sp.stockItems.map((i) => ({
                      value: i.id,
                      label: `${i.part_name}${
                        i.spesifikasi ? ` | ${i.spesifikasi}` : ""
                      } | Stock: ${i.stock} ${i.unit}`,
                    }))}
                    onChange={(selected) => {
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          itemId: selected ? selected.value : null,
                        };
                        return copy;
                      });
                    }}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Qty</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={sp.qty}
                    onChange={(e) =>
                      setSpareparts((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          qty: Number(e.target.value),
                        };
                        return copy;
                      })
                    }
                  />
                </Col>
              </Row>
            </Card>
          ))}
          <Button
            variant="outline-primary"
            size="sm"
            onClick={addSparepart}
            className="mb-2 mt-2"
          >
            <FontAwesomeIcon icon={faPlus} /> Tambah Sparepart
          </Button>

          <Form.Group>
            <Form.Label>Hasil</Form.Label>
            <Form.Control
              as="textarea"
              onChange={(e) => setHasilDirect(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Keterangan</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={keteranganDirect}
              onChange={(e) => setKeteranganDirect(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={submitDirect} disabled={savingDirect}>
            {savingDirect ? "Menyimpan..." : "Simpan"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MachinesTab;
